<script lang="ts">
    import Content from "../Content.svelte"

    export let block: ContentBlockEntry
</script>

{#if block.predefinedBlock?.include}
    <Content id="{block.predefinedBlock.include}" allwaysInView />
{/if}
